export const TIPPEK_EXCLUDED_URL_PREFIX = "hazassagkoto-terem";

export function withTippekNewsFilter(params = {}) {
    return {
        ...params,
        exclude_url_prefix: TIPPEK_EXCLUDED_URL_PREFIX
    };
}